import "./App.css";
import "./Sidebar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./link-theme.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./components/Login";
import Home from "./components/Home";
import React, { useCallback, useEffect, useState } from "react";
// import Alert from 'react-bootstrap/Alert';
// import MiniSidebar from "./components/MiniSidebar";
import * as constants from "./constants/CONSTANT";

// import PubSub from 'pubsub-js';
import { Alert, Toast, ToastContainer } from "react-bootstrap";
// import UserList from "./components/UserList";
// import UserView from "./components/UserView";
import { UserAdd, UserList, UserTracking, UserView } from "./components/user";
import jwt_decode from "jwt-decode";
import io from "socket.io-client";
import Main from "./components/layout/Main";

import WhatsAppMessenger from "./components/whatsapp_messenger/WhatsAppMessenger";
import WhatsAppSetting from "./components/whatsapp_setting/WhatsAppSetting";
import {
  Campaign,
  CampaignAdd,
  CampaignView,
  CampaignTracking,
} from "./components/campaign";
import { Templates, TemplateAdd } from "./components/whatsapp_template";
import Templateview from "./components/whatsapp_template/TemplateView";

import { Groups, GroupView } from "./components/groups";

// Added by shivani start
import LeadList from "./components/leads/LeadList";
import LeadView from "./components/leads/LeadView";
import LeadEdit from "./components/leads/LeadEdit";
import BlockedLeadsList from "./components/leads/BlockedLeadsList";
// Added by shivani end
import EditProfile from "./components/EditProfile";
import ResponseMessage from "./components/response_message/ResponseMessage";
import Module from "./components/module/Module";
import Plan from "./components/plan/Plan";
import CreatePlan from "./components/plan/CreatePlan";
import CompanyList from "./components/company/CompanyList";
import CreateCompany from "./components/company/CreateCompany";
import CompanyView from "./components/company/CompanyView";
import AddInvoice from "./components/invoices/AddInvoice";
import InvoiceView from "./components/invoices/InvoiceView";
import InvoiceLineItem from "./components/invoices/InvoiceLineItem";
import Addon from "./components/addon/Addon"; //Added by Yamini
import CreateAddon from "./components/addon/CreateAddon"; //Added by Yamini
import Invoices from "./components/invoices/Invoices";
import ProtectedRoute from "./components/common/ProtectedRoute";
import AccessDenied from "./components/common/AccessDenied";
import Leads from "./components/public_leads/Leads";
import LeadsAdd from "./components/public_leads/LeadsAdd";
import LeadsView from "./components/public_leads/LeadsView";
import PlanExpire from "./components/common/PlanExpire";
import Payment from "./components/Payment";
import Billing from "./components/Billing";
import {
  InteractiveMessage,
  AddInteractiveMessage,
} from "./components/interactive_message";
import { ChatBotFlowList, AddChatBot } from "./components/chatbot";
import { TagList } from "./components/tags";
import { ChatBotFlow, AddChatBotFlow } from "./components/chatbotflow";

import Wallet from "./components/wallet/Wallet";
import MyWallet from "./components/wallet/MyWallet";

import EmbeddedSignup from "./components/EmbeddedSignup";
import CoexistenceEmbeddedSignup from "./components/CoexistenceEmbeddedSignup";
// import RazorPay from "./components/rozerpay/RazorPay";

import WabasList from "./components/WabaList";
import CallHistory from "./components/calls/CallHistory";
import AllWhatsappSettings from "./components/public_settings/AllWhatsappSettings";
import { v4 as uuidv4 } from "uuid";
import AdManagerList from "./components/ad_manager/AdManagerList";
import WhatsAppAPI from "./api/WhatsAppAPI";
import authApi from "./api/authApi";

const ENDPOINT = "https://admin.watconnect.com";

// const ENDPOINT = 'https://api.indicrm.io/';

function App() {
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState("Confirmation");
  const [message, setMessage] = useState("");
  const [variant, setVariant] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [permissions, setPermissions] = useState();
  const [connectedSocket, setConnectedSocket] = useState();
  const [selectedWhatsAppSetting, setSelectedWhatsAppSetting] = useState(
    sessionStorage.getItem("selectedWhatsAppSetting") || "",
  );
  const [deviceId, setDeviceId] = useState(() => {
    let existingId = localStorage.getItem("deviceId");
    if (!existingId) {
      existingId = uuidv4();
      localStorage.setItem("deviceId", existingId);
    }
    return existingId;
  });
  const handleWhatsAppSettingChange = useCallback((newSettingId) => {
    setSelectedWhatsAppSetting(newSettingId);
  }, []);

  const mySubscriber = (msg, data) => {
    switch (msg) {
      case "RECORD_SAVED_TOAST":
        setTitle(data.title);
        setMessage(data.message);
        setModalShow(true);
        setVariant("success");
        break;
      case "RECORD_ERROR_TOAST":
        setTitle(data.title);
        setMessage(data.message);
        setModalShow(true);
        setVariant("danger");
        break;
      default:
        break;
    }
  };

  // Add this function in your App component
  const fetchWhatsAppSettings = async () => {
    try {
      const response = await WhatsAppAPI.getWhatsAppSettingRecord();
      if (response.success) {
        return response.record.map((setting) => setting.phone);
      }
      return [];
    } catch (error) {
      console.error("Error fetching WhatsApp settings:", error);
      return [];
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      return undefined;
    }

    let socketInstance = null;
    let cancelled = false;

    const initializeSocket = async () => {
      try {
        const user = jwt_decode(token);
        if (!cancelled) {
          setUserInfo(user);
        }

        const businessNumbers = await fetchWhatsAppSettings();
        if (cancelled) {
          return;
        }

        socketInstance = io(ENDPOINT, {
          path: "/ibs/socket.io",
          transports: ["websocket"],
          reconnection: true,
        });

        socketInstance.on("password_changed", () => {
          sessionStorage.clear();
          localStorage.clear();
          socketInstance.disconnect();
          authApi.logout();
        });

        socketInstance.on("connect", () => {
          socketInstance.emit("setup", {
            ...user,
            deviceId,
            business_numbers: businessNumbers,
            business_number:
              sessionStorage.getItem("selectedWhatsAppSetting") || "",
          });
          if (!cancelled) {
            setConnectedSocket(socketInstance);
          }
        });

        socketInstance.on("connected", () => {});
        socketInstance.on("receivedwhatsappmessage", () => {});
        socketInstance.on("disconnect", () => {});
        socketInstance.on("connect_error", () => {});
      } catch (error) {
        console.error("Error initializing socket:", error);
      }
    };

    initializeSocket();

    return () => {
      cancelled = true;
      if (socketInstance) {
        socketInstance.removeAllListeners();
        socketInstance.disconnect();
      }
      setConnectedSocket(undefined);
    };
  }, [sessionStorage.getItem("token"), deviceId]);
  return (
    <>
      <ToastContainer className="p-3" position="top-center">
        <Toast
          show={modalShow}
          onClose={() => setModalShow(false)}
          delay={3000}
          bg={variant}
          className="text-white"
          autohide
        >
          {variant === "success" ? (
            <div
              className="p-1 m-1"
              style={{ backgroundColor: "#198754", color: "white" }}
            >
              <i className="fa-regular fa-circle-check text-white mx-2"></i>
              <strong className="me-auto">{title}</strong>
              <i
                className="fa-solid fa-xmark text-white float-right"
                style={{ float: "right" }}
                role="button"
                onClick={() => setModalShow(false)}
              ></i>
            </div>
          ) : (
            <div
              className="p-1 m-1"
              style={{ backgroundColor: "#DC3545", color: "white" }}
            >
              <i className="fa-regular fa-circle-check text-white mx-2"></i>
              <strong className="me-auto">{title}</strong>
              <i
                className="fa-solid fa-xmark text-white float-right"
                style={{ float: "right" }}
                role="button"
                onClick={() => setModalShow(false)}
              ></i>
            </div>
          )}

          <Toast.Body>
            {message instanceof Array ? (
              message.map((item) => {
                return <span>{item.msg}</span>;
              })
            ) : message instanceof Object ? (
              <span>{message.detail}</span>
            ) : (
              <span>{message}</span>
            )}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/embeddedSignup" element={<EmbeddedSignup />} />
          <Route
            path="/coexistenceEmbeddedSignup"
            element={<CoexistenceEmbeddedSignup />}
          />

          <Route path="/chatbotflow" element={<ChatBotFlow />}></Route>
          <Route path="/chatbotflow/add" element={<AddChatBotFlow />}></Route>
          <Route
            path="/chatbotflow/:id/edit"
            element={<AddChatBotFlow />}
          ></Route>

          <Route
            path="/"
            element={
              <Main
                socket={connectedSocket}
                onWhatsAppSettingChange={handleWhatsAppSettingChange}
              />
            }
          >
            <Route
              index
              element={
                <Home
                  selectedWhatsAppSetting={selectedWhatsAppSetting}
                  userInfo={userInfo}
                />
              }
            />
            <Route path="/403" element={<AccessDenied />} />
            <Route path="/402" element={<PlanExpire userInfo={userInfo} />} />
            <Route path="/payment/:id" element={<Payment />} />
            <Route
              path="/chatbot"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="chatbot"
                />
              }
            >
              <Route
                index
                element={
                  <ChatBotFlowList
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
              <Route
                path="add"
                element={
                  <AddChatBot
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
              <Route
                path=":id/edit"
                element={
                  <AddChatBot
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
            </Route>
            {/*             
            <Route path="/chatbot" element={
              <ProtectedRoute
                userInfo={userInfo}
                userModules={userInfo?.modules}
                routeModule="chatbot"
              />
            }>
              <Route index element={<ChatBotFlowList selectedWhatsAppSetting={selectedWhatsAppSetting}  />}  />
            <Route path="add" element={<AddChatBot selectedWhatsAppSetting={selectedWhatsAppSetting}  />} />
            <Route path=":id/e" element={<AddChatBot selectedWhatsAppSetting={selectedWhatsAppSetting}  />} />
            </Route> */}

            <Route
              path="/wallet"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="wallet"
                />
              }
            >
              <Route index element={<Wallet />} />
            </Route>

            <Route path="/wallet" element={<Wallet />} />
            <Route path="/my_wallet" element={<MyWallet />} />
            <Route
              path="/tags"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="tags"
                />
              }
            >
              <Route index element={<TagList />} />
            </Route>

            <Route
              path="/interactive_message"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="interactive_message"
                />
              }
            >
              <Route
                index
                element={
                  <InteractiveMessage
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
              <Route
                path="add"
                element={
                  <AddInteractiveMessage
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
              <Route
                path=":id/e"
                element={
                  <AddInteractiveMessage
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
            </Route>
            <Route
              path="/addon"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="addon"
                />
              }
            >
              <Route index element={<Addon />} />
              <Route path="add" element={<CreateAddon />} />
              <Route path=":id/e" element={<CreateAddon />} />
            </Route>

            {/******** Show an User By Id *******/}

            <Route path="/users" element={<UserList />} />
            <Route path="users/e" element={<UserAdd />} />
            <Route path="users/:id/e" element={<UserAdd />} />
            <Route
              path="users/:id"
              element={
                <UserView selectedWhatsAppSetting={selectedWhatsAppSetting} />
              }
            />
            <Route path="/usertracking" element={<UserTracking />} />
            <Route path="/myprofile" element={<EditProfile />} />

            <Route
              path="/web_leads"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="web_leads"
                />
              }
            >
              <Route index element={<Leads />} />
              <Route path="add" element={<LeadsAdd />} />
              <Route path=":id" element={<LeadsAdd />} />
              <Route path="view/:id" element={<LeadsView />} />
            </Route>
            {/******** campaign *******/}
            <Route
              path="/campaign"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="campaign"
                />
              }
            >
              <Route
                index
                element={
                  <Campaign selectedWhatsAppSetting={selectedWhatsAppSetting} />
                }
              />
              <Route
                path="add"
                element={
                  <CampaignAdd
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                    userInfo={userInfo}
                  />
                }
              />
              <Route path="view/:id" element={<CampaignView />} />
              <Route
                path=":id"
                element={
                  <CampaignAdd
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                    userInfo={userInfo}
                  />
                }
              />
              <Route
                path="track/:id"
                element={
                  <CampaignTracking
                    socket={connectedSocket}
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                    userInfo={userInfo}
                  />
                }
              />
            </Route>

            {/******** Template *******/}
            <Route
              path="/whatsapp_template"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="whatsapp_template"
                />
              }
            >
              <Route
                index
                element={
                  <Templates
                    socket={connectedSocket}
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
              <Route
                path="add"
                element={
                  <TemplateAdd
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
              <Route
                path="view"
                element={
                  <Templateview
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
            </Route>

            <Route
              path="/whatsapp_messenger"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="whatsapp_messenger"
                />
              }
            >
              <Route
                index
                element={
                  <WhatsAppMessenger
                    socket={connectedSocket}
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
            </Route>

            <Route
              path="/calls"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="calls"
                />
              }
            >
              <Route
                index
                element={
                  <CallHistory
                    socket={connectedSocket}
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
            </Route>

            <Route
              path="/whatsapp_setting"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="whatsapp_setting"
                />
              }
            >
              <Route index element={<WhatsAppSetting />} />
            </Route>
            <Route
              path="/response_message"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="response_message"
                />
              }
            >
              <Route index element={<ResponseMessage />} />
            </Route>
            <Route
              path="/plan"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="plan"
                />
              }
            >
              <Route index element={<Plan />} />
              <Route path="add" element={<CreatePlan />} />
              <Route path=":id/e" element={<CreatePlan />} />
            </Route>

            <Route
              path="/module"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="module"
                />
              }
            >
              <Route index element={<Module />} />
            </Route>

            <Route
              path="/leads"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="leads"
                />
              }
            >
              <Route index element={<LeadList />} />
              <Route path="blocked" element={<BlockedLeadsList />} />
              <Route
                path=":id"
                element={
                  <LeadView
                    socket={connectedSocket}
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
              <Route path="e" element={<LeadEdit />} />
              <Route path=":id/e" element={<LeadEdit />} />
            </Route>

            <Route
              path="/groups"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="groups"
                />
              }
            >
              <Route index element={<Groups />} />
              <Route path=":groupId" element={<GroupView />} />
            </Route>

            <Route
              path="/company"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="company"
                />
              }
            >
              <Route index element={<CompanyList tabName="Company" />} />
              <Route
                path=":id"
                element={<CompanyView tabName="Company Details" />}
              />
              <Route
                path="add"
                element={<CreateCompany tabName="Create Company" />}
              />
              <Route
                path="edit/:id?"
                element={<CreateCompany tabName="Create Company" />}
              />
            </Route>

            <Route
              path="/invoice"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="invoice"
                />
              }
            >
              <Route index element={<Invoices tabName="Invoices" />} />
              <Route
                path="generate/:id"
                element={<AddInvoice tabName="Invoice" />}
              />
              <Route path=":id" element={<InvoiceView tabName="Invoice" />} />
              <Route
                path="invoiceitems/:id"
                element={<InvoiceLineItem tabName="Invoice" />}
              />
              <Route
                path="pay/:id"
                element={<AddInvoice tabName="Invoice" action="pay" />}
              />
            </Route>
            <Route
              path="/billing"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="billing"
                />
              }
            >
              <Route
                index
                element={
                  <Billing selectedWhatsAppSetting={selectedWhatsAppSetting} />
                }
              />
            </Route>
            <Route
              path="/ad_manager"
              element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="ad_manager"
                />
              }
            >
              <Route
                index
                element={
                  <AdManagerList
                    selectedWhatsAppSetting={selectedWhatsAppSetting}
                  />
                }
              />
            </Route>
            <Route path="/wabas" element={<WabasList />} />
            <Route path="/waba_settings" element={<AllWhatsappSettings />} />

            {/* <Route path="/razorpay" element={
                <ProtectedRoute
                  userInfo={userInfo}
                  userModules={userInfo?.modules}
                  routeModule="razorpay"
                />
              }>
            <Route index element={<RazorPay tabName="RazorPay" />} />
          </Route> */}
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
